import React from 'react';
import ProjectItem from './ProjectItem';

const ProjectList = ({ projects, onProjectClick }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {projects.map((project) => (
          <ProjectItem key={project.id} project={project} onClick={onProjectClick} />
        ))}
      </div>
      );
  };
  
export default ProjectList;
